import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import { SendWelcomeEmail } from "../../../api/Users";
import TextLoading from "../../../components/global/TextLoading";

export default function ModalSendWelcomeEmail(props) {
  const [t] = useTranslation(["global"]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(false);

  /*
   * Initial loading
   */
  useEffect(() => {
    Sentry.setTag("section", "Send Welcome Email Modal");
  }, []);

  /**
   * Description: Send Welcome Email to selected users
   */
  const sendWelcomeEmail = () => {
    setIsLoading(true);
    const usersIds = props.users.map((item) => item.id);
    const request = {
      user_ids: usersIds,
    };
    SendWelcomeEmail(request)
      .then((response) => {
        if (response.status) {
          props.onHide();
        } else {
          setErrors(response);
          Sentry.captureException(Error(JSON.stringify(response)));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Modal show={props.showModal} id="modalSendWelcomeEmail">
        <Modal.Header id="modalSendWelcomeEmailHeader">
          <Modal.Title id="modalSendWelcomeEmailTitle">
            {t("modalSendWelcomeEmail.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="modalSendWelcomeEmailBody">
          <Row id="sendWelcomeEmailDescription">
            <Col md={12}>{t("modalSendWelcomeEmail.description")}</Col>
          </Row>
          <Row className="mt-3" id="sendWelcomeEmailUserList">
            <Col md={12} style={{ maxHeight: "300px", overflow: "auto" }}>
              {props.users.map((item) => {
                return (
                  <p id={"sendWelcomeEmailUser-" + item.id} key={item.id}>
                    {"- " + item.name}
                  </p>
                );
              })}
            </Col>
          </Row>
          {errors && (
            <Row className="mt-3" id="sendWelcomeEmailErrors">
              <Col md={12}>
                <Alert variant="warning">{errors.description}</Alert>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            id="cancelSendWelcomeEmailBtn"
            onClick={() => props.onHide()}
            disabled={isLoading}
          >
            {t("global:buttons.cancel")}
          </Button>
          <Button
            variant="primary"
            id="sendWelcomeEmailBtn"
            onClick={sendWelcomeEmail}
            disabled={isLoading}
          >
            {isLoading ? (
              <TextLoading text={t("global:buttons.sending")} variant="light" />
            ) : (
              t("global:buttons.send")
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

ModalSendWelcomeEmail.propTypes = {
  showModal: PropTypes.bool,
  onHide: PropTypes.func,
  users: PropTypes.array,
};

ModalSendWelcomeEmail.defaultProps = {
  showModal: false,
  onHide: () => {},
  users: [],
};
